import type { IOfferParams, IRatesChartEvent, ISendOfferParams } from './events';
import {
  eventApplyForLoan,
  eventAuthorizationError,
  eventAuthorizationSuccess,
  eventButtonClick,
  eventCancelSelection,
  eventChangeFilter,
  eventChangeFormFieldDefaultParam,
  eventChangeLocation,
  eventChangePhoneNumber,
  eventClickBiometry,
  eventCloseSMSPopupClick,
  eventConsentsScreenButtonClick,
  eventEmptyOffers,
  eventFeedClick,
  eventFeedDecline,
  eventFeedFinishClick,
  eventFeedSuccess,
  eventFillFormField,
  eventFormFieldError,
  eventGetCodeBySms,
  eventGoEsiaFromBiometry,
  eventGoToOfferWebsite,
  eventInvalidForm,
  eventInvalidSmsCode,
  eventLoanConditions,
  eventMyApplications,
  eventOnChangeAmount,
  eventOnChangeFilter,
  eventOnClickActiveOfferConflictOnConditionsSelectionScreen,
  eventOnClickApprovalDateOnMplCreditSelectionScreen,
  eventOnClickApprovedOfferOnMplCreditSelectionScreen,
  eventOnClickButtonOffersOnOfferApprovalModal,
  eventOnClickChangeAmountOnMplCreditSelectionScreen,
  eventOnClickChangeLocation,
  eventOnClickChangeOption,
  eventOnClickFillManuallyButton,
  eventOnClickGosuslugiButton,
  eventOnClickGoToMainOnClientRefusedScreen,
  eventOnClickInsuranceDetails,
  eventOnClickNotSendSmsOnOfferDisbursementScreen,
  eventOnClickOfferCard,
  eventOnClickOpenDocumentOnOfferDisbursementScreen,
  eventOnClickRedirectToBankOnOfferDisbursementScreen,
  eventOnClickSelectOfferOnConditionsSelectionScreen,
  eventOnClickTermUnavailableReason,
  eventOnClickWhyRefusedOffersOnMplCreditSelectionScreen,
  eventOnClickWhyThisAmountOnMplCreditSelectionScreen,
  eventOnCloseApprovedOffersPopupOnMplCreditSelectionScreen,
  eventOnContinueButton,
  eventOnDisableAgreementPersonalData,
  eventOnDocumentClickOnAgreementSigningScreen,
  eventOnEditConditionsClickOnLoadingDocumentsScreen,
  eventOnEnableAgreementAdvertising,
  eventOnOpenDocumentsList,
  eventOnRatingDescriptionClickOnMplOffersLoadingScreen,
  eventOnSelectDocumentInChoiceModal,
  eventOnSendNewSmsAgreementSigning,
  eventOnSendSmsAgreementSigning,
  eventOnShowAgreementSignedScreen,
  eventOnShowAgreementSigningScreen,
  eventOnShowApprovedOfferOnMplCreditSelectionScreen,
  eventOnShowApprovedOffersPopupOnMplCreditSelectionScreen,
  eventOnShowClientRefusedScreen,
  eventOnShowConditionsSelectionScreen,
  eventOnShowCoolingPeriodScreen,
  eventOnShowLoadingDocumentsScreen,
  eventOnShowMplOffersLoadingScreenStep,
  eventOnShowNotSendSmsModalOnOfferDisbursementScreen,
  eventOnShowOfferApprovalModal,
  eventOnShowOfferDisbursementScreen,
  eventOnShowPDNOnMplOffersLoadingScreen,
  eventOnShowRatingDescriptionPopupOnMplOffersLoadingScreen,
  eventOnShowRefusedOffersOnMplCreditSelectionScreen,
  eventOnShowTopXOnMplCreditSelectionScreen,
  eventOnShowWhyNeedCoolingPeriodModal,
  eventOnSmsErrorAgreementSigning,
  eventOnSubmitAgreementSigning,
  eventOnSubmitClickTopXOnMplCreditSelectionScreen,
  eventOnSubmitOffer,
  eventOnToggleInsuranceOnConditionsSelectionScreen,
  eventOpenConsentsScreen,
  eventPaidClick,
  eventRatesChartChange,
  eventRatesChartInit,
  eventRatesChartSelectItem,
  eventRatesChartViewItem,
  eventRequestNewCode,
  eventSendOffer,
  eventShowBiometry,
  eventShowFullDealBlock,
  eventShowLandingPage,
  eventShowOffers,
  eventShowStep,
  eventStepAdditionalData,
  eventStepContacts,
  eventStepCreditPurpose,
  eventStepPassport,
  eventStepWorkplace,
  eventSubmitFullDealApplication,
  eventValidationError,
} from './events';
import { sendEventToGA } from './sendEventToGA';

export const sendEventOnShowConditionsSelectionScreen = (
  ...args: Parameters<typeof eventOnShowConditionsSelectionScreen>
) => sendEventToGA(eventOnShowConditionsSelectionScreen(...args));

export const sendEventOnClickTermUnavailableReason = (...args: Parameters<typeof eventOnClickTermUnavailableReason>) =>
  sendEventToGA(eventOnClickTermUnavailableReason(...args));

export const sendEventOnClickChangeOption = (...args: Parameters<typeof eventOnClickChangeOption>) =>
  sendEventToGA(eventOnClickChangeOption(...args));

export const sendEventOnClickInsuranceDetails = (...args: Parameters<typeof eventOnClickInsuranceDetails>) =>
  sendEventToGA(eventOnClickInsuranceDetails(...args));

export const sendEventOnOpenDocumentsList = (...args: Parameters<typeof eventOnOpenDocumentsList>) =>
  sendEventToGA(eventOnOpenDocumentsList(...args));

export const sendEventOnChangeAmount = (...args: Parameters<typeof eventOnChangeAmount>) =>
  sendEventToGA(eventOnChangeAmount(...args));

export const sendEventOnEditConditionsClickOnLoadingDocumentsScreen = (
  ...args: Parameters<typeof eventOnEditConditionsClickOnLoadingDocumentsScreen>
) => sendEventToGA(eventOnEditConditionsClickOnLoadingDocumentsScreen(...args));

export const sendEventOnShowLoadingDocumentsScreen = (...args: Parameters<typeof eventOnShowLoadingDocumentsScreen>) =>
  sendEventToGA(eventOnShowLoadingDocumentsScreen(...args));

export const sendEventOnSelectDocumentInChoiceModal = (
  ...args: Parameters<typeof eventOnSelectDocumentInChoiceModal>
) => sendEventToGA(eventOnSelectDocumentInChoiceModal(...args));

export const sendEventOnShowAgreementSigningScreen = (...args: Parameters<typeof eventOnShowAgreementSigningScreen>) =>
  sendEventToGA(eventOnShowAgreementSigningScreen(...args));

export const sendEventOnDocumentClickOnAgreementSigningScreen = (
  ...args: Parameters<typeof eventOnDocumentClickOnAgreementSigningScreen>
) => sendEventToGA(eventOnDocumentClickOnAgreementSigningScreen(...args));

export const sendEventOnSubmitAgreementSigning = (...args: Parameters<typeof eventOnSubmitAgreementSigning>) =>
  sendEventToGA(eventOnSubmitAgreementSigning(...args));

export const sendEventOnSendSmsAgreementSigning = (...args: Parameters<typeof eventOnSendSmsAgreementSigning>) =>
  sendEventToGA(eventOnSendSmsAgreementSigning(...args));

export const sendEventOnSmsErrorAgreementSigning = (...args: Parameters<typeof eventOnSmsErrorAgreementSigning>) =>
  sendEventToGA(eventOnSmsErrorAgreementSigning(...args));

export const sendEventOnSendNewSmsAgreementSigning = (...args: Parameters<typeof eventOnSendNewSmsAgreementSigning>) =>
  sendEventToGA(eventOnSendNewSmsAgreementSigning(...args));

export const sendEventOnShowOfferApprovalModal = (...args: Parameters<typeof eventOnShowOfferApprovalModal>) =>
  sendEventToGA(eventOnShowOfferApprovalModal(...args));

export const sendEventOnClickButtonOffersOnOfferApprovalModal = (
  ...args: Parameters<typeof eventOnClickButtonOffersOnOfferApprovalModal>
) => sendEventToGA(eventOnClickButtonOffersOnOfferApprovalModal(...args));

export const sendEventOnShowCoolingPeriodScreen = (...args: Parameters<typeof eventOnShowCoolingPeriodScreen>) =>
  sendEventToGA(eventOnShowCoolingPeriodScreen(...args));

export const sendEventOnShowWhyNeedCoolingPeriodModal = (
  ...args: Parameters<typeof eventOnShowWhyNeedCoolingPeriodModal>
) => sendEventToGA(eventOnShowWhyNeedCoolingPeriodModal(...args));

export const sendEventOnShowAgreementSignedScreen = (...args: Parameters<typeof eventOnShowAgreementSignedScreen>) =>
  sendEventToGA(eventOnShowAgreementSignedScreen(...args));

export const sendEventOnShowOfferDisbursementScreen = (
  ...args: Parameters<typeof eventOnShowOfferDisbursementScreen>
) => sendEventToGA(eventOnShowOfferDisbursementScreen(...args));

export const sendEventOnClickNotSendSmsOnOfferDisbursementScreen = (
  ...args: Parameters<typeof eventOnClickNotSendSmsOnOfferDisbursementScreen>
) => sendEventToGA(eventOnClickNotSendSmsOnOfferDisbursementScreen(...args));

export const sendEventOnShowNotSendSmsModalOnOfferDisbursementScreen = (
  ...args: Parameters<typeof eventOnShowNotSendSmsModalOnOfferDisbursementScreen>
) => sendEventToGA(eventOnShowNotSendSmsModalOnOfferDisbursementScreen(...args));

export const sendEventOnClickRedirectToBankOnOfferDisbursementScreen = (
  ...args: Parameters<typeof eventOnClickRedirectToBankOnOfferDisbursementScreen>
) => sendEventToGA(eventOnClickRedirectToBankOnOfferDisbursementScreen(...args));

export const sendEventOnClickOpenDocumentOnOfferDisbursementScreen = (
  ...args: Parameters<typeof eventOnClickOpenDocumentOnOfferDisbursementScreen>
) => sendEventToGA(eventOnClickOpenDocumentOnOfferDisbursementScreen(...args));

export const sendEventOnShowClientRefusedScreen = (...args: Parameters<typeof eventOnShowClientRefusedScreen>) =>
  sendEventToGA(eventOnShowClientRefusedScreen(...args));

export const sendEventOnClickGoToMainOnClientRefusedScreen = (
  ...args: Parameters<typeof eventOnClickGoToMainOnClientRefusedScreen>
) => sendEventToGA(eventOnClickGoToMainOnClientRefusedScreen(...args));

export const sendEventOnClickSelectOfferOnConditionsSelectionScreen = (
  ...args: Parameters<typeof eventOnClickSelectOfferOnConditionsSelectionScreen>
) => sendEventToGA(eventOnClickSelectOfferOnConditionsSelectionScreen(...args));

export const sendEventOnClickActiveOfferConflictOnConditionsSelectionScreen = (
  ...args: Parameters<typeof eventOnClickActiveOfferConflictOnConditionsSelectionScreen>
) => sendEventToGA(eventOnClickActiveOfferConflictOnConditionsSelectionScreen(...args));

export const sendEventOnToggleInsuranceOnConditionsSelectionScreen = (
  ...args: Parameters<typeof eventOnToggleInsuranceOnConditionsSelectionScreen>
) => sendEventToGA(eventOnToggleInsuranceOnConditionsSelectionScreen(...args));

export const sendEventPaidClick = (data: ISendOfferParams) => sendEventToGA(eventPaidClick(data));
export const sendEventOfferSent = (data: ISendOfferParams) => sendEventToGA(eventSendOffer(data));
export const sendEventRatesChartInit = (data: IRatesChartEvent) => sendEventToGA(eventRatesChartInit(data));
export const sendEventRatesChartChange = (label: string, value: string) =>
  sendEventToGA(eventRatesChartChange(label, value));

export const sendEventRatesChartViewItem = (label: string) => sendEventToGA(eventRatesChartViewItem(label));

export const sendEventRatesChartSelectItem = (label: string, data: IRatesChartEvent) =>
  sendEventToGA(eventRatesChartSelectItem(label, data));

export const sendEventFillFormField = (...args: Parameters<typeof eventFillFormField>) =>
  sendEventToGA(eventFillFormField(...args));

export const sendEventFormFieldError = (...args: Parameters<typeof eventFormFieldError>) =>
  sendEventToGA(eventFormFieldError(...args));

export const sendEventInvalidForm = (...args: Parameters<typeof eventInvalidForm>) =>
  sendEventToGA(eventInvalidForm(...args));

export const sendEventChangeFormFieldDefaultParam = (...args: Parameters<typeof eventChangeFormFieldDefaultParam>) =>
  sendEventToGA(eventChangeFormFieldDefaultParam(...args));

export const sendEventGetCodeBySms = () => sendEventToGA(eventGetCodeBySms());

export const sendEventInvalidSmsCode = () => sendEventToGA(eventInvalidSmsCode());

export const sendEventChangePhoneNumber = () => sendEventToGA(eventChangePhoneNumber());

export const sendEventRequestNewCode = () => sendEventToGA(eventRequestNewCode());

export const sendEventAuthorizationError = (...args: Parameters<typeof eventAuthorizationError>) =>
  sendEventToGA(eventAuthorizationError(...args));

export const sendEventAuthorizationSuccess = (...args: Parameters<typeof eventAuthorizationSuccess>) =>
  sendEventToGA(eventAuthorizationSuccess(...args));

export const sendEventStepContacts = (...args: Parameters<typeof eventStepContacts>) =>
  sendEventToGA(eventStepContacts(...args));

export const sendEventStepCreditPurpose = (...args: Parameters<typeof eventStepCreditPurpose>) =>
  sendEventToGA(eventStepCreditPurpose(...args));

export const sendEventStepPassport = (...args: Parameters<typeof eventStepPassport>) =>
  sendEventToGA(eventStepPassport(...args));

export const sendEventAdditionalData = (...args: Parameters<typeof eventStepAdditionalData>) =>
  sendEventToGA(eventStepAdditionalData(...args));

export const sendEventStepWorkplace = (...args: Parameters<typeof eventStepWorkplace>) =>
  sendEventToGA(eventStepWorkplace(...args));

export const sendEventShowStep = (...args: Parameters<typeof eventShowStep>) => sendEventToGA(eventShowStep(...args));

export const sendEventShowOffers = (...args: Parameters<typeof eventShowOffers>) =>
  sendEventToGA(eventShowOffers(...args));

export const sendEventEmptyOffers = (...args: Parameters<typeof eventEmptyOffers>) =>
  sendEventToGA(eventEmptyOffers(...args));

export const sendEventChangeLocation = () => sendEventToGA(eventChangeLocation());

export const sendEventChangeFilter = (label: string) => sendEventToGA(eventChangeFilter(label));

export const sendEventGoToOfferWebsite = (params: IOfferParams) => sendEventToGA(eventGoToOfferWebsite(params));

export const sendEventOpenConsentsScreen = () => sendEventToGA(eventOpenConsentsScreen());

export const sendEventConsentsScreenButtonClick = (...args: Parameters<typeof eventConsentsScreenButtonClick>) =>
  sendEventToGA(eventConsentsScreenButtonClick(...args));

export const sendEventOnDisableAgreementPersonalData = () => sendEventToGA(eventOnDisableAgreementPersonalData());

export const sendEventOnEnableAgreementAdvertising = () => sendEventToGA(eventOnEnableAgreementAdvertising());

export const sendEventOnShowMplOffersLoadingScreenStep = (
  ...args: Parameters<typeof eventOnShowMplOffersLoadingScreenStep>
) => sendEventToGA(eventOnShowMplOffersLoadingScreenStep(...args));

export const sendEventOnRatingDescriptionClickOnMplOffersLoadingScreen = (
  ...args: Parameters<typeof eventOnRatingDescriptionClickOnMplOffersLoadingScreen>
) => sendEventToGA(eventOnRatingDescriptionClickOnMplOffersLoadingScreen(...args));

export const sendEventOnShowRatingDescriptionPopupOnMplOffersLoadingScreen = (
  ...args: Parameters<typeof eventOnShowRatingDescriptionPopupOnMplOffersLoadingScreen>
) => sendEventToGA(eventOnShowRatingDescriptionPopupOnMplOffersLoadingScreen(...args));

export const sendEventOnShowPDNOnMplOffersLoadingScreen = (
  ...args: Parameters<typeof eventOnShowPDNOnMplOffersLoadingScreen>
) => sendEventToGA(eventOnShowPDNOnMplOffersLoadingScreen(...args));

export const sendEventOnShowApprovedOffersPopupOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnShowApprovedOffersPopupOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnShowApprovedOffersPopupOnMplCreditSelectionScreen(...args));

export const sendEventOnCloseApprovedOffersPopupOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnCloseApprovedOffersPopupOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnCloseApprovedOffersPopupOnMplCreditSelectionScreen(...args));

export const sendEventOnShowApprovedOfferOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnShowApprovedOfferOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnShowApprovedOfferOnMplCreditSelectionScreen(...args));

export const sendEventOnClickApprovedOfferOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnClickApprovedOfferOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnClickApprovedOfferOnMplCreditSelectionScreen(...args));

export const sendEventOnClickWhyThisAmountOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnClickWhyThisAmountOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnClickWhyThisAmountOnMplCreditSelectionScreen(...args));

export const sendEventOnClickChangeAmountOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnClickChangeAmountOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnClickChangeAmountOnMplCreditSelectionScreen(...args));

export const sendEventOnClickApprovalDateOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnClickApprovalDateOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnClickApprovalDateOnMplCreditSelectionScreen(...args));

export const sendEventOnShowTopXOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnShowTopXOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnShowTopXOnMplCreditSelectionScreen(...args));

export const sendEventOnSubmitClickTopXOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnSubmitClickTopXOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnSubmitClickTopXOnMplCreditSelectionScreen(...args));

export const sendEventOnShowRefusedOffersOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnShowRefusedOffersOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnShowRefusedOffersOnMplCreditSelectionScreen(...args));

export const sendEventOnClickWhyRefusedOffersOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnClickWhyRefusedOffersOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnClickWhyRefusedOffersOnMplCreditSelectionScreen(...args));

export const sendEventShowFullDealBlock = (...args: Parameters<typeof eventShowFullDealBlock>) =>
  sendEventToGA(eventShowFullDealBlock(...args));

export const sendEventApplyForLoan = (...args: Parameters<typeof eventApplyForLoan>) =>
  sendEventToGA(eventApplyForLoan(...args));

export const sendEventLoanConditions = (...args: Parameters<typeof eventLoanConditions>) =>
  sendEventToGA(eventLoanConditions(...args));

export const sendEventCancelSelection = (...args: Parameters<typeof eventCancelSelection>) =>
  sendEventToGA(eventCancelSelection(...args));

export const sendEventSubmitFullDealApplication = (...args: Parameters<typeof eventSubmitFullDealApplication>) =>
  sendEventToGA(eventSubmitFullDealApplication(...args));

export const sendEventMyApplications = (...args: Parameters<typeof eventMyApplications>) =>
  sendEventToGA(eventMyApplications(...args));

export const sendEventButtonClick = (...args: Parameters<typeof eventButtonClick>) =>
  sendEventToGA(eventButtonClick(...args));

export const sendEventValidationError = (...args: Parameters<typeof eventValidationError>) =>
  sendEventToGA(eventValidationError(...args));

export const sendEventCloseSMSPopupClick = () => sendEventToGA(eventCloseSMSPopupClick());

export const sendEventShowLandingPage = () => sendEventToGA(eventShowLandingPage());

export const sendEventOnClickChangeLocation = () => sendEventToGA(eventOnClickChangeLocation());

export const sendEventOnContinueButton = () => sendEventToGA(eventOnContinueButton());

export const sendEventOnClickFillManuallyButton = () => sendEventToGA(eventOnClickFillManuallyButton());

export const sendEventOnClickGosuslugiButton = () => sendEventToGA(eventOnClickGosuslugiButton());

export const sendEventOnClickOfferCard = (...args: Parameters<typeof eventOnClickOfferCard>) =>
  sendEventToGA(eventOnClickOfferCard(...args));

export const sendEventOnSubmitOffer = (...args: Parameters<typeof eventOnSubmitOffer>) =>
  sendEventToGA(eventOnSubmitOffer(...args));

export const sendEventOnChangeFilter = (...args: Parameters<typeof eventOnChangeFilter>) =>
  sendEventToGA(eventOnChangeFilter(...args));

export const sendEventClickBiometry = () => sendEventToGA(eventClickBiometry());

export const sendEventShowBiometry = () => sendEventToGA(eventShowBiometry());

export const sendEventGoEsiaFromBiometry = (...args: Parameters<typeof eventGoEsiaFromBiometry>) =>
  sendEventToGA(eventGoEsiaFromBiometry(...args));

export const sendEventFeedClick = (...args: Parameters<typeof eventFeedClick>) =>
  sendEventToGA(eventFeedClick(...args));

export const sendEventFeedDecline = (...args: Parameters<typeof eventFeedDecline>) =>
  sendEventToGA(eventFeedDecline(...args));

export const sendEventFeedSuccess = (...args: Parameters<typeof eventFeedSuccess>) =>
  sendEventToGA(eventFeedSuccess(...args));

export const sendEventFeedFinishClick = (...args: Parameters<typeof eventFeedFinishClick>) =>
  sendEventToGA(eventFeedFinishClick(...args));
